
import React from "react";
import { ResourceFile } from "../types";
import { TrainingContentViewer } from "../TrainingContentViewer";

interface TrainingContentProps {
  currentFile: ResourceFile | undefined;
  currentFileIndex: number;
  files: ResourceFile[];
  isQuizView: boolean;
  isFreeResponseView: boolean;
  isDragDropView: boolean;
  isLinkingView: boolean;
  isTrainee: boolean;
  isAdmin: boolean;
  isFileLocked: (index: number) => boolean;
  completedFiles: {[key: string]: boolean};
  overallProgress: number;
  resourceId: string;
  markFileCompleted: (fileId: string) => Promise<void>;
  loadingError: string | null;
  setLoadingError: (error: string | null) => void;
  freeResponseQuestions: any[];
  quiz: any;
  isLoadingQuiz: boolean;
  quizCompleted: boolean;
  quizAttempt: any;
  handleQuizComplete: (quizId: string, attempt: any) => Promise<void>;
  handleContentComplete: () => void;
  handleDragDropComplete: (fileId: string, attempt: any) => Promise<void>;
  handleFileChange: (index: number) => void;
}

export function TrainingContent({
  currentFile,
  currentFileIndex,
  files,
  isQuizView,
  isFreeResponseView,
  isDragDropView,
  isLinkingView,
  isTrainee,
  isAdmin,
  isFileLocked,
  completedFiles,
  overallProgress,
  resourceId,
  markFileCompleted,
  loadingError,
  setLoadingError,
  freeResponseQuestions,
  quiz,
  isLoadingQuiz,
  quizCompleted,
  quizAttempt,
  handleQuizComplete,
  handleContentComplete,
  handleDragDropComplete,
  handleFileChange
}: TrainingContentProps) {
  return (
    <TrainingContentViewer
      currentFile={currentFile}
      currentFileIndex={currentFileIndex}
      files={files}
      isQuizView={isQuizView}
      isFreeResponseView={isFreeResponseView}
      isDragDropView={isDragDropView}
      isLinkingView={isLinkingView}
      isTrainee={isTrainee}
      isAdmin={isAdmin}
      isFileLocked={isFileLocked}
      completedFiles={completedFiles}
      overallProgress={overallProgress}
      resourceId={resourceId}
      markFileCompleted={markFileCompleted}
      quiz={quiz}
      isLoadingQuiz={isLoadingQuiz}
      quizCompleted={quizCompleted}
      quizAttempt={quizAttempt}
      handleQuizComplete={handleQuizComplete}
      handleContentComplete={handleContentComplete}
      handleDragDropComplete={handleDragDropComplete}
      loadingError={loadingError}
      setLoadingError={setLoadingError}
      onComplete={() => {
        if (currentFileIndex < files.length - 1) {
          handleFileChange(currentFileIndex + 1);
        }
      }}
      freeResponseQuestions={freeResponseQuestions}
    />
  );
}
